import React, { createContext, useState } from 'react';

export interface IRedirectContextProps {
  redirectTo: string | null;
  setRedirectTo: (path: string | null) => void;
  consumeRedirect: () => string | null;
}

// eslint-disable-next-line react-refresh/only-export-components
export const RedirectContext = createContext<IRedirectContextProps | undefined>(
  undefined,
);

export const RedirectProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [redirectTo, setRedirectTo] = useState<string | null>(null);

  const consumeRedirect = () => {
    const target = redirectTo;
    setRedirectTo(null);
    return target;
  };

  return (
    <RedirectContext.Provider
      value={{
        redirectTo,
        setRedirectTo,
        consumeRedirect,
      }}
    >
      {children}
    </RedirectContext.Provider>
  );
};
